export default (points) =>
    points.reduce(
        (acc, [x, y]) => `${acc} ${acc === '' ? 'M' : 'L'} ${x} ${y}`,
        ''
    )
